import {
  type GetPayV3Query,
  type GetPayV3TooltipQuery,
  type GetPayV3TopGeosQuery,
  PAY_V3_QUERY,
  PAY_V3_TOOLTIP_QUERY,
  PAY_V3_TOPGEOS_QUERY,
  type PayV3Req,
} from '@revelio/data-access';

import type { DataProviderQueryStatus } from '../types';
import { useUrqlQueryWithStatus } from '../utils/data-provider-results-utils';

type PayVariant = 'full' | 'tooltip' | 'topGeos';

type PayDataByVariant = {
  full: GetPayV3Query;
  tooltip: GetPayV3TooltipQuery;
  topGeos: GetPayV3TopGeosQuery;
};

const QUERIES = {
  full: PAY_V3_QUERY,
  tooltip: PAY_V3_TOOLTIP_QUERY,
  topGeos: PAY_V3_TOPGEOS_QUERY,
} as const;

/** Runs the variant's `pay_v3` query. */
export function usePayData<V extends PayVariant>({
  variant,
  req,
  pause = false,
}: {
  variant: V;
  req: PayV3Req;
  pause?: boolean;
}): {
  data: PayDataByVariant[V] | undefined;
  status: DataProviderQueryStatus;
} {
  const [{ data, status }] = useUrqlQueryWithStatus({
    query: QUERIES[variant],
    variables: { req },
    pause,
  });

  return {
    data: data as PayDataByVariant[V] | undefined,
    status,
  };
}
